import { render, staticRenderFns } from "./section10OtherExemption.vue?vue&type=template&id=b11f6510&scoped=true"
import script from "./section10OtherExemption.vue?vue&type=script&lang=js"
export * from "./section10OtherExemption.vue?vue&type=script&lang=js"
import style0 from "./section10OtherExemption.vue?vue&type=style&index=0&id=b11f6510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11f6510",
  null
  
)

export default component.exports